import { Application } from '@salsita-ai/platform-project-sdk/admin'
import { createGetApplicationWrapperHandler } from '@salsita-ai/platform-project-sdk/domain'
import { ResourceUrlProvider } from '@salsita-ai/platform-project-sdk/react'

export const getApplicationWrapperHandler = createGetApplicationWrapperHandler(config => {
  return () => (
    <ResourceUrlProvider
      baseResourcesUrl={config.resources?.baseResourcesUrl ?? config.defaultEnvs?.resourcesUrl ?? ''}
      deploymentId={config.defaultEnvs?.deploymentId ?? ''}
      deploymentQueryDisabled={config.resources?.deploymentQueryDisabled ?? false}
    >
      <Application config={config} />
    </ResourceUrlProvider>
  )
})
